import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

export default function CreateVideoInvoiceModal({ isOpen, onClose, onCreated }) {
  const [students, setStudents] = useState([]);
  const [courses, setCourses] = useState([]);
  const [studentId, setStudentId] = useState("");
  const [selectedCourses, setSelectedCourses] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    setStudentId("");
    setSelectedCourses([]);

    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/getStudent`)
      .then((response) => {
        if (response.data.success) {
          setStudents(
            response.data.data.map((s) => ({
              value: s.student_id,
              label: `${s.surname || ""} ${s.first_name || ""} (${s.student_id})`.trim(),
            }))
          );
        } else {
          console.error("Failed to fetch students:", response.data.message);
          alert("Failed to load students. Please try again.");
          setStudents([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching students:", err);
        alert("Error loading students. Please check your connection.");
        setStudents([]);
      });

    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/getCourse`)
      .then((response) => {
        if (response.data.success) {
          setCourses(
            response.data.data.map((c) => ({
              value: c.course_name,
              label: c.course_name,
            }))
          );
        } else {
          console.error("Failed to fetch courses:", response.data.message);
          alert("Failed to load courses. Please try again.");
          setCourses([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching courses:", err);
        alert("Error loading courses. Please check your connection.");
        setCourses([]);
      });
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!studentId) {
      alert("Please select a student.");
      return;
    }
    if (selectedCourses.length === 0) {
      alert("Please select at least one course.");
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/admin/video/create`, {
        student_id: studentId,
        course_names: selectedCourses.map((c) => c.value),
      });
      alert("Video invoice created successfully!");
      onClose();
      if (onCreated) onCreated();
    } catch (err) {
      console.error("Error creating video invoice:", err);
      alert(err.response?.data?.error || err.message || "Failed to create invoice.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg w-1/2 max-w-lg">
        <h3 className="text-xl font-semibold mb-5">Create Video Invoice</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-5">
            <label className="block text-gray-700 mb-1 font-medium">Student:</label>
            <Select
              options={students}
              onChange={(selected) => setStudentId(selected ? selected.value : "")}
              placeholder="Search for a student..."
              isClearable
              className="w-full"
              classNamePrefix="react-select"
            />
          </div>
          <div className="mb-5">
            <label className="block text-gray-700 mb-1 font-medium">Courses:</label>
            <Select
              isMulti
              options={courses}
              value={selectedCourses}
              onChange={setSelectedCourses}
              placeholder="Select one or more courses..."
              className="w-full"
              classNamePrefix="react-select"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
            />
            {selectedCourses.length > 0 && (
              <div className="mt-2 text-sm text-gray-600">
                Selected: {selectedCourses.map((c) => c.label).join(", ")}
              </div>
            )}
          </div>
          <div className="flex justify-end mt-6 space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white px-5 py-2 rounded hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
              disabled={!studentId || selectedCourses.length === 0}
            >
              Create Invoice
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
